import { inViewCallback } from './inviewCallback';
export default function addClassWhenInView(params) {
    const scope = params.scope && document.querySelector(params.scope);
    const observedElements = scope
        ? scope.querySelectorAll(params.elements)
        : document.querySelectorAll(params.elements);
    observedElements.forEach((element) => {
        element.classList.add('spv-inview');
    });
    const observer = new IntersectionObserver(inViewCallback, params.options);
    observedElements.forEach(element => {
        observer.observe(element);
    });
}
addClassWhenInView({
    elements: '[data-inview]',
    options: {
        threshold: 0.1,
    },
});
//# sourceMappingURL=addClassWhenInView.js.map